export const sliceText = (text, size, isMobile = false, slidesToShow) => {
  if (!text) return '';

  // const calculateLength = [{s: }]

  const sizesMapExample = () => {
    if (!isMobile && slidesToShow <= 1) {
      return { s: 180, m: 200, l: 220 };
    }

    if (slidesToShow > 1) {
      return {
        s: 180 / slidesToShow,
        m: 200 / slidesToShow,
        l: 220 / slidesToShow,
      };
    }

    if (isMobile) {
      return { s: 40, m: 60, l: 100 };
    }
  };

  const maxLength = sizesMapExample()[size] ?? sizesMapExample().s;

  if (text.length <= maxLength) return text;

  let sliced = text.slice(0, maxLength);

  if (text.charAt(maxLength) !== ' ') {
    const lastSpaceIndex = sliced.lastIndexOf(' ');
    if (lastSpaceIndex !== -1) {
      sliced = sliced.slice(0, lastSpaceIndex);
    }
  }

  return sliced + '...';
};
